/**
 * SN_SAI_BIL_REP_001 — 거래처 포인트 내역 (본사) (2026-09-18, 2차 검토 확정)
 *
 * 호출별 내역(sai_callh ⋈ sai_calll) — 거래처 · 사용자 · 용도 · LLM회사 · 등급 · 모델 · 입력토큰 · 출력토큰 · 원가(원) · 포인트 · 정산상태 · 처리결과 · 응답시간.
 * 본사가 전체 거래처를 본다. 거래처 자기 화면은 AI 사용내역(SN_SAI_USE_REP_001).
 *
 * 조회조건 · 그리드 컬럼 · 폼 · 팝업 정의는 DB(sys_formctrl · sys_formgridcolumn · sys_popup*, 08_AI_화면설정.sql)에서 온다. 조회는 sys_query sn_sai_bil_rep_001_01.
 * 본 : 사용자 등록 SN_SYS_AUT_REG_004 (조회 + 그리드 1, 조회만)
 */
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

const SN_SAI_BIL_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1 || [],
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_sai_bil_rep_001_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data?.[0] || [],
      });
    } catch (error: any) {}
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel ref={searchRef} data={formData} controls={formControlData} />
      </div>
      <div className="w-full flex h-full min-h-0 space-x-1.5">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "포인트 내역", isEditable: false }}
            events={grids.grid1.events}
          />
      </div>
    </div>
  );
});

export default SN_SAI_BIL_REP_001;
